// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"5eca4356","343":"540aa103","419":"fba687b7","527":"8cc30ace","616":"c9cc8d2d","656":"b255318c","736":"0e5af4b3","742":"232854b7","787":"d012feab","865":"acc798e8","893":"2ea7e2d5","962":"175fb7ab","964":"be113e3e"}[chunkId] + ".chunk.js";
};